/**
 * Action types for the CreatePayee reducer
 * These constants define the available actions that can be dispatched to update payee state
 */
export enum PayeeActionTypes {
  SET_PAYEE_DETAILS_ENTITY_AND_INVESTMENT = "SET_PAYEE_DETAILS_ENTITY_AND_INVESTMENT",
  SET_PAYEE_DETAILS_VENDOR = "SET_PAYEE_DETAILS_VENDOR",
  SET_INVOICES = "SET_INVOICES",
  SET_SUPPORTING_DOCUMENTS = "SET_SUPPORTING_DOCUMENTS",
  SET_CLIENT_DETAILS_ARENA = "SET_CLIENT_DETAILS_ARENA",
  SET_TAX_DOCUMENTS = "SET_TAX_DOCUMENTS",
  SET_PAYMENT_PREF = "SET_PAYMENT_PREF",
}

/**
 * Action types for the CreatePayeeStep reducer
 * These constants define the available actions that can be dispatched to control step navigation
 */
export enum PayeeStepActionTypes {
  INCREMENT_STEP = "INCREMENT_STEP",
  DECREMENT_STEP = "DECREMENT_STEP",
}
